import { useMemo } from "react";

import useApi from "../../hooks/api";

import {
  buildIncidenceTypesRepository,
  buildCollaboratorsRepository,
  buildPeriodTypesRepository,
} from "../infrastructure";
import { createUseIncidenceTypes } from "./useIncidenceTypes";
import { createUseCollaborators } from "./useCollaborators";
import { createUsePeriodTypes } from "./usePeriodTypes";

export const useIncidenceTypes = () => {
  const { genericApiCall } = useApi();

  const incidenceTypesRepository = useMemo(
    () => buildIncidenceTypesRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useIncidenceTypesQuery = useMemo(
    () => createUseIncidenceTypes({ incidenceTypesRepository }),
    [incidenceTypesRepository],
  );

  return useIncidenceTypesQuery();
};

export const useCollaborators = () => {
  const { genericApiCall } = useApi();

  const collaboratorsRepository = useMemo(
    () => buildCollaboratorsRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const useCollaboratorsQuery = useMemo(
    () => createUseCollaborators({ collaboratorsRepository }),
    [collaboratorsRepository],
  );

  return useCollaboratorsQuery();
};

export const usePeriodTypes = () => {
  const { genericApiCall } = useApi();

  const periodTypesRepository = useMemo(
    () => buildPeriodTypesRepository({ apiCaller: genericApiCall }),
    [genericApiCall],
  );

  const usePeriodTypesQuery = useMemo(
    () => createUsePeriodTypes({ periodTypesRepository }),
    [periodTypesRepository],
  );

  return usePeriodTypesQuery();
};
